module.exports = __webpack_public_path__ + "static/35-seat-midi-coach-hire-5b5bb19de1532cc5823e2d2b6af7ea29.jpg";